import { useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { useUser } from "utils/userContext";
import { getSubscriptionRedirectPath } from "utils/subscription";

export default function AuthRedirect({ children, requirePaidAccess = false }) {

    const { user, loading, hasPaidAccess } = useUser();
    const navigate = useNavigate();
    const location = useLocation();


    useEffect(() => {
        const currentPath = location.pathname + location.search;

        if (!loading && !user) {
            console.log("User not logged in, redirecting to login page");
            navigate(`/login?redirectTo=${encodeURIComponent(currentPath)}`);
            return;
        }

        if (!loading && requirePaidAccess && user && !user.isGuest && !hasPaidAccess) {
            navigate(getSubscriptionRedirectPath(currentPath), { replace: true });
        }
    }, [user, loading, navigate, location, requirePaidAccess, hasPaidAccess]);

    if (!user && !loading) {
        return <p className="text-center text-white p-8 font-bold">Redirecting to login...</p>;
    }

    if (!loading && requirePaidAccess && user && !user.isGuest && !hasPaidAccess) {
        return <p className="text-center text-white p-8 font-bold">Redirecting to subscription...</p>;
    }

    return <>{children}</>;
}
